import Minze, { EventListeners, MinzeElement, Reactive } from "minze";
import { Locale } from "../../modules/locale";
import { EMAIL_REGEX } from "../../modules/utils";
import { submitForm } from "../../constants";
import { SquidexTextLabels } from "../../modules/squidex/labels";

Locale.getInstance().registerKeySet("fr", "servicesForm", {
  nameLabel: "Nom de la personne contact",
  emailLabel: "Adresse courriel de la personne contact",
  schoolLabel: "Nom de l'école",
  academicCenterLabel: "Nom du centre de services scolaires",
  regionLabel: "Région",
  send: "Envoyer",
  requiredError: "Requis",
  invalidEmailError: "Le courriel est invalide",
  submittedMessage: "Votre demande a été envoyée.",
  regionsOptionLabels:
    "Abitibi-Témiscamingue,Bas-Saint-Laurent,Capitale-Nationale,Centre-du-Québec,Chaudière-Appalaches,Côte-Nord,Estrie,Gaspésie–Îles-de-la-Madeleine,Lanaudière,Laurentides,Laval,Mauricie,Montérégie,Montréal,Nord-du-Québec,Outaouais,Saguenay–Lac-Saint-Jean",
});

Locale.getInstance().registerKeySet("en", "servicesForm", {
  nameLabel: "Full Name",
  emailLabel: "Email",
  schoolLabel: "Name of School",
  academicCenterLabel: "Name of Academic Services Center",
  regionLabel: "Region",
  send: "Submit",
  requiredError: "Required",
  invalidEmailError: "Email is invalid",
  submittedMessage: "Your request has been sent.",
  regionsOptionLabels:
    "Abitibi-Témiscamingue,Bas-Saint-Laurent,Capitale-Nationale,Centre-du-Québec,Chaudière-Appalaches,Côte-Nord,Estrie,Gaspésie–Îles-de-la-Madeleine,Lanaudière,Laurentides,Laval,Mauricie,Montérégie,Montréal,Nord-du-Québec,Outaouais,Saguenay–Lac-Saint-Jean",
});

export interface TjServicesForm {
  errors: { [fieldName: string]: string };
  values: { [fieldName: string]: any };
  submitted: boolean;
}

export class TjServicesForm extends MinzeElement {
  reactive: Reactive = [
    ["errors", {}],
    ["values", {}],
    ["submitted", false],
  ];
  isMobile = window.matchMedia("(max-width: 768px)").matches;

  submitForm = async () => {
    this.submitted = false;
    this.errors = {};
    const nameField = this.select(`#name`)?.getAttribute("value");
    const emailField = this.select(`#email`)?.getAttribute("value");
    const schoolField = this.select(`#school`)?.getAttribute("value");
    const academicCenterField =
      this.select(`#academicCenter`)?.getAttribute("value");
    const regionField = this.select(`#region`)?.getAttribute("value");
    this.values = {
      name: nameField,
      email: emailField,
      school: schoolField,
      academicCenter: academicCenterField,
      region: regionField,
    };
    if (!nameField)
      this.errors = {
        ...this.errors,
        name: SquidexTextLabels.getKey("servicesForm.requiredError"),
      };
    if (!emailField)
      this.errors = {
        ...this.errors,
        email: SquidexTextLabels.getKey("servicesForm.requiredError"),
      };
    else if (!EMAIL_REGEX.test(emailField)) {
      this.errors = {
        ...this.errors,
        email: SquidexTextLabels.getKey("servicesForm.invalidEmailError"),
      };
    }
    if (!schoolField)
      this.errors = {
        ...this.errors,
        school: SquidexTextLabels.getKey("servicesForm.requiredError"),
      };
    if (!academicCenterField)
      this.errors = {
        ...this.errors,
        academicCenter: SquidexTextLabels.getKey("servicesForm.requiredError"),
      };
    if (!regionField)
      this.errors = {
        ...this.errors,
        region: SquidexTextLabels.getKey("servicesForm.requiredError"),
      };
    if (!Object.values(this.errors).length) {
      const response = await submitForm("3inn894", this.values);
      if (response.status === "success") {
        this.submitted = true;
        this.values = {};
        Minze.cast("tj:services-form-submitted");
        this.rerender(true);
      }
    }
    this.rerender();
  };
  html = () => `
    <tj-box mb="16px" display="flex" flexDirection="${this.isMobile ? "column" : "row"}" rowGap="16px" columnGap="16px">
      <tj-input
        id="name"
        name="name"
        placeholder="${SquidexTextLabels.getKey("servicesForm.nameLabel")}"
        error="${this.errors["name"]}"
        value="${this.values["name"]}"
      ></tj-input>
    </tj-box>
    <tj-box mb="16px">
      <tj-input
        id="email"
        name="email"
        type="email"
        placeholder="${SquidexTextLabels.getKey("servicesForm.emailLabel")}"
        error="${this.errors["email"]}"
        value="${this.values["email"]}"
      ></tj-input>
    </tj-box>
    <tj-box mb="16px" display="flex" flexDirection="${this.isMobile ? "column" : "row"}" rowGap="16px" columnGap="16px">
      <tj-input
        id="school"
        name="school"
        placeholder="${SquidexTextLabels.getKey("servicesForm.schoolLabel")}"
        error="${this.errors["school"]}"
        value="${this.values["school"]}"
      ></tj-input>
    </tj-box>
    <tj-box mb="16px" display="flex" flexDirection="${this.isMobile ? "column" : "row"}" rowGap="16px" columnGap="16px">
      <tj-input
        id="academicCenter"
        name="academicCenter"
        placeholder="${SquidexTextLabels.getKey("servicesForm.academicCenterLabel")}"
        error="${this.errors["academicCenter"]}"
        value="${this.values["academicCenter"]}"
      ></tj-input>
    </tj-box>
    <tj-box mb="16px" display="flex" flexDirection="${this.isMobile ? "column" : "row"}" rowGap="16px" columnGap="16px">
      <tj-select
        id="region"
        name="region"
        placeholder="${SquidexTextLabels.getKey("servicesForm.regionLabel")}"
        default-value=""
        selectOptions="${SquidexTextLabels.getKey("servicesForm.regionsOptionLabels")}"
        selectOptionLabels="${SquidexTextLabels.getKey("servicesForm.regionsOptionLabels")}"
        error="${this.errors["region"]}"
        value="${this.values["region"]}"
      ></tj-select>
    </tj-box>
    <tj-box mb="16px" display="flex" alignItems="center" justifyContent="space-between">
      <tj-button id="submit" name="save" size="small" width="fit-content" class="services-form-submit-button" >
        ${SquidexTextLabels.getKey("servicesForm.send")}
      </tj-button>
      ${this.submitted ? `<tj-text>${SquidexTextLabels.getKey("servicesForm.submittedMessage")}</tj-text>` : ""}
    </tj-box>
  `;

  css = () => `
    .title {
      font-weight: 500;
      font-size: 40px;
      line-height: 120%;
      color: #1E007D;
      margin: 80px 0 8px 0;
    }
  `;
  eventListeners: EventListeners = [["#submit", "click", this.submitForm]];
}
